"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _text = require("@mmc/text");

var _commonOptionCard = require("@mmc/common-option-card");

var _commonRichText = require("@mmc/common-rich-text");

var _commonI18n = require("@mmc/common-i18n");

var _reactRedux = require("react-redux");

var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _configuratorPackageSelectorAccordionWrapper = _interopRequireDefault(require("./configurator-package-selector-accordion-wrapper"));

var _configuratorPackageSelector = _interopRequireDefault(require("../styles/configurator-package-selector.css"));

var _configuratorPackageSelector2 = require("./configurator-package-selector.props/configurator-package-selector.propTypes");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _DataUtils = new _mmcDataUtilities["default"](),
    handleNestedProp = _DataUtils.handleNestedProp,
    appendImageOptimization = _DataUtils.appendImageOptimization;

var imageWidth = 600;

var ConfiguratorPackageSelectorCardWrapper = function ConfiguratorPackageSelectorCardWrapper(_ref) {
  var filterPackage = _ref.filterPackage,
      theme = _ref.theme,
      config = _ref.config,
      changeEvent = _ref.changeEvent,
      selectedPackages = _ref.selectedPackages,
      forcedOptionCodes = _ref.forcedOptionCodes,
      notCompatibleOptionCodes = _ref.notCompatibleOptionCodes,
      addPriceDisclaimer = _ref.addPriceDisclaimer,
      priceDisclaimerId = _ref.priceDisclaimerId,
      disclaimerData = _ref.disclaimerData;
  var description = handleNestedProp(filterPackage, 'filterPackage.titleAndText.text');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _configuratorPackageSelector["default"].packageSelectorCardContainer
  }, /*#__PURE__*/_react["default"].createElement(_commonOptionCard.CommonOptionCard, {
    theme: theme,
    name: "package-" + filterPackage.type,
    value: filterPackage.code,
    label: filterPackage.label,
    fullTap: false,
    type: "checkbox",
    isSelected: selectedPackages.includes(filterPackage.code),
    disabled: forcedOptionCodes.includes(filterPackage.code) || notCompatibleOptionCodes.includes(filterPackage.code),
    onChange: changeEvent
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _configuratorPackageSelector["default"].cardText
  }, filterPackage.price && /*#__PURE__*/_react["default"].createElement("p", {
    className: _configuratorPackageSelector["default"].packagePrice + " " + theme.bodyCopy
  }, filterPackage.price.value !== undefined && handleNestedProp(filterPackage, 'filterPackage.price.label'), /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
    format: "price",
    returnZero: true,
    options: {
      value: handleNestedProp(filterPackage, 'filterPackage.price.value'),
      currency: handleNestedProp(config, 'config.currencyFormat'),
      locale: handleNestedProp(config, 'config.localeCode')
    },
    addPriceDisclaimer: addPriceDisclaimer,
    priceDisclaimerId: priceDisclaimerId,
    disclaimerData: disclaimerData
  })), /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    className: _configuratorPackageSelector["default"].cardTextImage + " " + _configuratorPackageSelector["default"].fullSize,
    src: appendImageOptimization(handleNestedProp(filterPackage, 'filterPackage.image.image'), imageWidth, undefined, undefined, 70 //eslint-disable-line
    ),
    alt: handleNestedProp(filterPackage, 'filterPackage.image.altText')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.bodyCopy
  }, description !== ' ' && /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
    theme: theme,
    html: description
  }))), filterPackage.includedOptions && /*#__PURE__*/_react["default"].createElement(_configuratorPackageSelectorAccordionWrapper["default"], {
    includedOptions: filterPackage.includedOptions,
    theme: theme
  }))));
};

ConfiguratorPackageSelectorCardWrapper.displayName = 'ConfiguratorPackageSelectorCardWrapper';
ConfiguratorPackageSelectorCardWrapper.defaultProps = {
  filterPackage: null
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(ConfiguratorPackageSelectorCardWrapper);

exports["default"] = _default;